import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import toast from "react-hot-toast";
const FaultType = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const regions = ["South1", "South2", "South3", "West", "North", "Central"];

  const handleStatus = ({ id }) => {
    const updatedData = [...owners];
    const currentStatus = updatedData[id].status || "on";
    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
  };



  const MasterList = async (search) => {
    setSearchValue(search);
    const payload = {
      type: 3,
      search: search,
      pagination: page,
    }
    let res = await post(URLS.MASTERLIST, payload)
    if (res?.status == "success") {
      setList(res?.masters);
    }
  }

  useEffect(() => {
    MasterList();
  }, []);


  const statusChange = async (id) => {
    console.log("id", id);

    const payload = {
      id: id,
    }
    let res = await post(URLS.MASTERSTATUS + id, payload)
    if (res?.status == "success") {
      toast.success(res?.message)
      // setList(res?.admins);
      MasterList()
    }
  }





  const [owners, setOwners] = useState([
    { faultname: "Power Failure", status: "on" },
    { faultname: "Network Issue", status: "off" },
    { faultname: "Hardware Malfunction", status: "on" },
    { faultname: "Software Crash", status: "on" },
    { faultname: "Sensor Error", status: "off" },
    { faultname: "Overheating", status: "on" },
    { faultname: "Connectivity Drop", status: "on" },
    { faultname: "Battery Drain", status: "off" },
    { faultname: "Display Error", status: "on" },
    { faultname: "Configuration Fault", status: "on" },
  ]);


  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },

      {
        Header: "Fault Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },


      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js mt-2">
            <button
              onClick={() => statusChange(row.original.id)}
              className={`${value === 0 ? "deactive-icon1" : "active-icon1"
                } f2 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15  fs-xxl-16`}
            >
              {value === 0 ? "De-active" : "Active"}
            </button>
          </div>
        ),
      },


      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js mt-2 gap-3">
                <button
                  onClick={() => {
                    navigate("/fault-add", { state: { type: "view", id: row?.original?.id, data: row?.original } });
                  }}
                  className="cust-btn "
                >
                  <img src={view} alt="" className=" editor-btn " />
                </button>

                <button
                  onClick={() => {
                    navigate("/fault-add", { state: { type: "edit", id: row?.original?.id, data: row?.original } });
                  }}
                  className="cust-btn "
                >
                  <img src={edit} alt="" className=" editor-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <Topbar header={"Fault Type"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total :{list?.length}
          </h4>
          <button
            onClick={() =>
              navigate("/fault-add", { state: { type: "add" } })
            }
            className="Add_btn1 f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Add
          </button>
        </div>
        <div className="d-flex ac-je gap-4">


          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input value={searchValue} onChange={(e) => MasterList(e.target.value)}
              type="text"
              placeholder="Search "
              style={{ border: "none", width: "200px" }}
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list}
          show={false}
        />
      </div>
    </>
  );
};

export default FaultType;
